import type { BrandRegionCode } from "core/entities";
import { useBrand } from "./useBrand";
import { useRegion } from "./useRegion";

export function useBrandRegionCode(): BrandRegionCode {
  const { brandCode } = useBrand();
  const region = useRegion();
  return `${brandCode}${region}` as BrandRegionCode;
}
